import { useState, useEffect } from 'react'
import UnsavedAuctionModal from './UnsavedAuctionModal'
import { setSessionItem } from './utils'

export default function UnsavedAuctionCheck() {

  const [showModal, setShowModal] = useState()

  const [sessionAuction, setSessionAuction] = useState(() => {
    const stored = sessionStorage.getItem('unsavedAuction')
    return stored ? JSON.parse(stored) : null
  })

  const [historyProps, setHistoryProps] = useState(() => {
    const stored = sessionStorage.getItem('historyProps')
    return stored ? JSON.parse(stored) : null
  })

  const [imageUploadInProgress, setImageUploadInProgress] = useState(() => {
    const stored = sessionStorage.getItem('imageUploadInProgress')
    return stored ? JSON.parse(stored) : null
  })

  useEffect(() => {
    const handleSessionChange = (event) => {
      // console.log('event', event)
      if (event.detail.key === 'unsavedAuction') {
        setSessionAuction(event.detail.value)
      }

      if (event.detail.key === 'historyProps') {
        setHistoryProps(event.detail.value)
      }

      if (event.detail.key === 'imageUploadInProgress') {
        setImageUploadInProgress(event.detail.value)
      }
    }

    window.addEventListener('session-storage-change', handleSessionChange)

    return () => {
      window.removeEventListener('session-storage-change', handleSessionChange)
    }
  }, [])

  useEffect(() => {

    // check if history prop has POP event and matches current URL during image upload
    if (historyProps && historyProps.action === 'POP' && imageUploadInProgress === true) {
      const currentPath = window.location.pathname
      const currentSearch = window.location.search
      const historyPath = historyProps.location?.pathname
      const historySearch = historyProps.location?.search
      
      // If history location matches current URL location during image upload
      if (currentPath === historyPath && currentSearch === historySearch) {
        // Reset history prop, keep unsaved auction, remove imageUploadInProgress
        setSessionItem('historyProps', null)
        setSessionItem('imageUploadInProgress', null)
        setShowModal(false)
        return
      }
    }

    if (sessionAuction === undefined && historyProps !== undefined) {
      setShowModal(false)
    } else if (sessionAuction !== 'null' && historyProps !== 'null' && historyProps?.location?.pathname !== undefined && imageUploadInProgress !== true) {
      setShowModal(true)
    } else {
      setShowModal(false)
    }

  }, [sessionAuction, historyProps, imageUploadInProgress])

  if (!sessionAuction || sessionAuction === 'null') {
    return null
  }

  const loseChanges = () => {
    setSessionItem('unsavedAuction', null)
    setSessionItem('historyProps', null)
    setSessionItem('imageUploadInProgress', null)
    setShowModal(false)
  }

  const handleBack = () => {
    setShowModal(false)
    setSessionItem('imageUploadInProgress', null)
    window.location.href = `/admin/auctiondetail?auctionId=${sessionAuction.auctionCode}`
  }

  return (
    <>
      {showModal && <UnsavedAuctionModal setShowConfirmModal={setShowModal} loseChanges={loseChanges} backToAuction={handleBack} />}
    </>
  )
}